import type {PayloadAction} from '@reduxjs/toolkit'
import type {SagaIterator} from 'redux-saga'
import {takeLatest, put, call} from 'redux-saga/effects'
import {standardErrorAction} from 'helpers/saga'
import {queryClient} from 'main'
import {updateEntity} from 'store/entity/asyncHelpers'
import type {Tour} from 'types/tour'
import type {EntityUpdateParams} from '../../types'
import {updateTourSuccess} from '../actions'
import {UPDATE, UPDATE_FAILURE} from '../constants'

export function* updateTour(
  action: PayloadAction<EntityUpdateParams<Tour>>
): SagaIterator<Tour> {
  try {
    const payload = yield call(() =>
      updateEntity({
        kind: 'TOUR',
        id: action.payload.id,
        data: action.payload,
      })
    )
    yield put(updateTourSuccess(payload))
    queryClient.invalidateQueries({queryKey: ['bookingEvents']})
    return payload
  } catch (e: any) {
    yield put(standardErrorAction(UPDATE_FAILURE, e))
    throw e
  }
}

export function* updateSaga() {
  yield takeLatest(UPDATE, updateTour)
}
